import _asyncToGenerator from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/regenerator/index.js";
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

import { getWellKnown, getKey } from './endpoints/well-known.js';
import AuthSdkError from '../errors/AuthSdkError.js';
import '../errors/WWWAuthError.js';
import { getOidcHash } from '../crypto/oidcHash.js';
import { verifyToken as verifyToken$1 } from '../crypto/verifyToken.js';
import { validateClaims } from './util/validateClaims.js';
import './types/Token.js';
import { decodeToken } from './decodeToken.js';
function verifyToken(_x, _x2, _x3) {
  return _verifyToken.apply(this, arguments);
}
function _verifyToken() {
  _verifyToken = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(sdk, token, validationParams) {
    var jwt, configuredIssuer, _yield$getWellKnown, issuer, validationOptions, key, valid, hash;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(!token || !token.idToken)) {
            _context.next = 2;
            break;
          }
          throw new AuthSdkError('Only idTokens may be verified');
        case 2:
          jwt = decodeToken(token.idToken);
          configuredIssuer = (validationParams === null || validationParams === void 0 ? void 0 : validationParams.issuer) || sdk.options.issuer;
          _context.next = 6;
          return getWellKnown(sdk, configuredIssuer);
        case 6:
          _yield$getWellKnown = _context.sent;
          issuer = _yield$getWellKnown.issuer;
          validationOptions = Object.assign({
            clientId: sdk.options.clientId,
            ignoreSignature: sdk.options.ignoreSignature
          }, validationParams, {
            issuer: issuer
          });
          validateClaims(sdk, jwt.payload, validationOptions);
          if (!(validationOptions.ignoreSignature == true || !sdk.features.isTokenVerifySupported())) {
            _context.next = 12;
            break;
          }
          return _context.abrupt("return", token);
        case 12:
          _context.next = 14;
          return getKey(sdk, token.issuer, jwt.header.kid);
        case 14:
          key = _context.sent;
          _context.next = 17;
          return verifyToken$1(token.idToken, key);
        case 17:
          valid = _context.sent;
          if (valid) {
            _context.next = 20;
            break;
          }
          throw new AuthSdkError('The token signature is not valid');
        case 20:
          if (!(validationParams && validationParams.accessToken && token.claims.at_hash)) {
            _context.next = 26;
            break;
          }
          _context.next = 23;
          return getOidcHash(validationParams.accessToken);
        case 23:
          hash = _context.sent;
          if (!(hash !== token.claims.at_hash)) {
            _context.next = 26;
            break;
          }
          throw new AuthSdkError('Token hash verification failed');
        case 26:
          return _context.abrupt("return", token);
        case 27:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _verifyToken.apply(this, arguments);
}
export { verifyToken };